import React from "react";
import { Link } from "react-router-dom";
import './breadcrumbs.scss'

const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, index) => (
          <li
            key={index}
            className={`breadcrumb-item ${
              index === items.length - 1 ? "active" : ""
            }`}
            {...(index === items.length - 1 ? { "aria-current": "page" } : {})}
          >
            {index !== items.length - 1 ? (
              <Link to={item.href || "#"}>{item.label}</Link>
            ) : (
              item.label
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
